import React from "react";
import { WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "@/lib/api";

export default function Footer() {
    return (
        <footer className="bg-[var(--gf-navy)] text-white mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="mb-4">
                        <img src="/logo.png" alt="Gestión Fiscal 347" className="h-20 w-auto object-contain" style={{ filter: "brightness(0) invert(1)" }} />
                    </div>
                    <p className="text-white/70 text-sm max-w-md leading-relaxed mt-4">
                        Interpretamos el balance de tu empresa con rigor contable español y te ofrecemos consejos estratégicos accionables.
                    </p>
                </div>

                <div>
                    <div className="micro-label text-white/50 mb-4">Contacto</div>
                    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
                       className="flex items-center gap-2 text-sm mb-3 hover:text-[var(--gf-gold)]" data-testid="footer-whatsapp">
                        <WhatsappLogo size={18} weight="fill" /> +34 604 080 483
                    </a>
                    <a href="mailto:info@gf347.es" className="flex items-center gap-2 text-sm hover:text-[var(--gf-gold)]" data-testid="footer-email">
                        <EnvelopeSimple size={18} /> info@gf347.es
                    </a>
                </div>

                <div>
                    <div className="micro-label text-white/50 mb-4">Legal</div>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><a href="/aviso-legal" className="hover:text-[var(--gf-gold)]" data-testid="footer-aviso-legal">Aviso legal</a></li>
                        <li><a href="/privacidad" className="hover:text-[var(--gf-gold)]" data-testid="footer-privacidad">Política de privacidad</a></li>
                        <li><a href="/cookies" className="hover:text-[var(--gf-gold)]" data-testid="footer-cookies">Política de cookies</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between text-xs text-white/50">
                    <div>© 2026 Gestión Fiscal 347 · Todos los derechos reservados</div>
                    <div>Hecho con rigor contable en España</div>
                </div>
            </div>
        </footer>
    );
}
